import { render } from "./PatientDetail.vue?vue&type=template&id=5d79cd1a&ts=true"
import script from "./PatientDetail.vue?vue&type=script&lang=ts"
export * from "./PatientDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__